import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [TranslateModule, ButtonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() public label = '';
  @Input() public size?: 'small' | 'large';
  @Input() public status: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'help' | 'danger' | 'contrast' =
    'primary';
  @Input() public outlined = false;
  @Input() public isLink = false;
  @Input() public raised = false;
  @Input() public rounded = false;
  @Input() public icon = '';
  @Input() public iconPosition: 'left' | 'right' | 'top' | 'bottom' = 'left';
  @Input() public loading = false;
  @Input() public disabled = false;

  @Output() public buttonClicked = new EventEmitter<boolean>();
}
